import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-hover" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Device id"),
    /*#__PURE__*/_createElementVNode("th", null, "Kind"),
    /*#__PURE__*/_createElementVNode("th", null, "Brand"),
    /*#__PURE__*/_createElementVNode("th", null, "Model"),
    /*#__PURE__*/_createElementVNode("th", null, "Serial number")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EndUserDeviceRow = _resolveComponent("EndUserDeviceRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.css}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
              return (_openBlock(), _createBlock(_component_EndUserDeviceRow, {
                key: device.device_id,
                device: device
              }, null, 8, ["device"]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}